import React from 'react';

import { noop } from 'lodash-es';

import { ActionsheetWrapper } from 'components/action-sheet';

import { ReorderCard, ReorderItemsList } from '..';

import { ActionsheetContentStyled } from './styled';
import { ReorderDetailsDrawerProps } from './types';

export const ReorderDetailsDrawer = ({
  showDrawer,
  toggleDetailsDrawer,
  order,
  openDetailEventMessage,
}: ReorderDetailsDrawerProps) => {
  return (
    <ActionsheetWrapper
      onOpenEventMessage={openDetailEventMessage}
      isOpen={showDrawer}
      onClose={toggleDetailsDrawer}
    >
      <ActionsheetContentStyled>
        <ReorderItemsList
          orderEntries={order.orderEntries}
          ListHeaderComponent={() => (
            <ReorderCard
              order={order}
              toggleDetailsDrawer={toggleDetailsDrawer}
              drawerIsOpen={showDrawer}
              logViewEvent={noop}
              logReorderEvent={noop}
              logOpenDetailEvent={noop}
            />
          )}
        />
      </ActionsheetContentStyled>
    </ActionsheetWrapper>
  );
};
